import { render, staticRenderFns } from "./StyleDialog.vue?vue&type=template&id=f8fb3f28&scoped=true&"
import script from "./StyleDialog.vue?vue&type=script&lang=js&"
export * from "./StyleDialog.vue?vue&type=script&lang=js&"
import style0 from "./StyleDialog.vue?vue&type=style&index=0&id=f8fb3f28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8fb3f28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTabItem } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCol,VRow,VTabItem})
